<template>
  <div class="special">
    <div class="special-overview-wrap">
      <div class="special-overview-inner">
        <div class="catch-wrap">
          <p class="catch-main" v-html="mainCatch">
          </p>
          <p class="catch-sub" v-html="subCatch">
          </p>
        </div>
        <div class="intro-wrap">
          <p class="intro" v-html="intro">
          </p>
        </div>
      </div>
    </div>
    <div class="hero">
      <img v-bind:src="image" v-bind:alt="alt" class="over_display" />
      <img v-bind:src="imageSp" v-bind:alt="alt" class="under_display" />
    </div>
    <slot/>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'special',
  props: {
    image: String,
    imageSp: String,
    alt:String,
    mainCatch: String,
    subCatch: String,
    intro:String,
  }
}
</script>

<style lang="scss" scoped>
.special {
  width: 100%;
  position: relative;
}
.hero {
  width:1500px ;
  position: absolute;
  top: 115px;
  left: 50%;
  transform: translateX(-50%);
  @media print, screen and (max-width: 1160px) {
    position: relative;
    width:100% ;
    top: 0;
	}
}

.special-overview{
  &-wrap{
    width:100%;
    position: relative;
  }
  &-inner{
    width:650px;
    width: 650px;
    padding: 250px 0 0;
    margin: 0 auto;
		font-family: 'ots-mincho', serif;
    text-align: center;
    @media print, screen and (max-width: 1160px) {
      padding: 7% 0 5%;
      width: 100%;
    }
    p{
      margin: 0;
      letter-spacing: 0.02em;
    }
    .catch-main{
      font-size: 53px;
      @media print, screen and (max-width: 1160px) {
        font-size: max(26px, 4.9vw);
      }
    }
    .catch-sub{
      font-size: 40px;
      line-height: 1em;
      margin-bottom: 1.5em;
      @media print, screen and (max-width: 1160px) {
        font-size: max(20px, 3.4vw);
      }
    }
    .intro-wrap{
      margin-top: 10px;
      .intro{
        font-size: 21px;
        line-height: 2.5em;
        @media print, screen and (max-width: 1160px) {
          text-align:left;
          font-size: max(14px, 1.8vw);
          max-width: 90%;
          width: auto;
          margin: 0 auto;
          display: inline-block;
        }
      }
    }
  }
}
</style>
